import React from "react";
import { useDashboardHeaderData } from "../hooks/useDashboardHeaderData";

// Import Images
import CountIcon1 from "../assets/images/count-icon1.png";
import CountIcon2 from "../assets/images/count-icon2.png";

const StudentsSelected = () => {
  const {
    data: dashboardHeaderData,
    isLoading,
    isError,
    error,
  } = useDashboardHeaderData();

  const bottomData = dashboardHeaderData?.bottom_data;
  const hasBottomData = Number(bottomData?.is_bottom_data) === 1;
  const selectionCount = Number(bottomData?.number_of_selections || 0).toLocaleString("en-IN");
  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load students selected data."
    : "";

  return (
    <div className="selected-Student students-selected-card">
    <div className="students-wrap">
      <div className="text-center">
        {isLoading ? <p className="students-selected-card__status">Loading students selected...</p> : null}
        {!isLoading && loadError ? <p className="students-selected-card__status students-selected-card__status--error">{loadError}</p> : null}
        {!isLoading && !loadError && !hasBottomData ? (
          <p className="students-selected-card__status">No students selected data available.</p>
        ) : null}

        {!isLoading && !loadError && hasBottomData ? (
          <>
        <h1 className="fw-bolder d-flex justify-content-center align-items-center students-selected-card__count">
          <img
            src={CountIcon1}
            alt=""
            className="studentCount"
          />
          <span>{selectionCount}</span>
          <img
            src={CountIcon2}
            alt=""
            className="studentCount"
          />
        </h1>

        <h4 className="students-selected-card__title fw-bold">{bottomData?.title || "Students Selected"}</h4>

        <p className="students-selected-card__subtitle fw-medium mx-auto">
          {bottomData?.description || ""}
        </p>

        {bottomData?.image_url ? (
          <div className="students-selected-card__imageWrap">
            <img
              src={bottomData.image_url}
              alt={bottomData?.title || "Students Selected"}
              className="students-selected-card__banner"
            />
          </div>
        ) : null}
          </>
        ) : null}
      </div>
    </div>
    </div>
  );
};

export default StudentsSelected;
